/**
 * Where a ```scrambl-cards``` record opens inside the web client portal.
 *
 * A client's portal is a much smaller map than the app: portal Benny only
 * cards tasks, tickets, projects, notes and threads, and everything else has
 * nowhere to land. A task opens inside its project (the project page reads
 * `?taskId=`), so a task card without a `projectId` stays put rather than
 * opening the wrong page. Mirrors the mobile app's `getPortalCardRoute`.
 */
export function getPortalAssistantCardPath(
  entityId: string,
  card: { type: string; id: string },
): string | null {
  const base = `/client-portal/${encodeURIComponent(entityId)}`
  const id = encodeURIComponent(card.id)
  switch (card.type.toLowerCase()) {
    case 'task': {
      const projectId = (card as { projectId?: unknown }).projectId
      if (typeof projectId !== 'string' || !projectId) return null
      return `${base}/projects/${encodeURIComponent(projectId)}?taskId=${id}`
    }
    case 'ticket':
      return `${base}/tickets/${id}`
    case 'project':
      return `${base}/projects/${id}`
    case 'note':
      return `${base}/notes/${id}`
    case 'thread':
      return `${base}/threads/${id}`
    default:
      return null
  }
}
